/* eslint-disable react/no-danger, react/react-in-jsx-scope */
import '~/polyfills';
import ThemeProvider from '@carvana/showroom-theme';
import type { AppProps } from 'next/app';
import Head from 'next/head';
import { useEffect, useState } from 'react';
import Footer from '@/Search/components/Footer';
import { assetsUrl } from '~/constants/environment';
import initDataDog from '~/datadog';
import theme from '~/theme';
import { loadFooterMfe } from '~/utilities/MicroFrontEnds';

import 'tailwindcss/tailwind.css';
import '@carvana/showroom-css-theme/Reset.css';
import '@carvana/showroom-css-theme/Theme.css';
import '@carvana/showroom-css-theme/Font.css';
import '@carvana/showroom-forms/index.css';
import '@carvana/showroom-tabs/index.css';
import '~/global.css';

// TODO: Component styles should be rewritten to CSS modules
import '@/FiltersMenu/Budget/BudgetFinance/CashDownDescriptors.scss';
import '@/SearchResults/ResultSearchRedesign/LowResultSearch.scss';
import '@/SearchResults/ResultTile/ResultTile.scss';
import '@/ConditionalTiles/CTTooltip/CTTooltip.scss';
import '@/ConditionalTiles/CTTooltip/CTTooltipContent.scss';
import '@/ConditionalTiles/CTTooltip/Tooltip.scss';
import '~/styles/Collapse/Collapse.css';
import '~/styles/TextField/TextField.css';
import '~/styles/Tooltip/tooltipStyles.css';

// Polyfill for web-vitals npm package that allows for FID in all browsers plus more accurate reporting.
const webVitalsPolyfill = `
!function(){var e,t,n,i,r={passive:!0,capture:!0},a=new Date,o=function(){i=[],t=-1,e=null,f(addEventListener)},c=function(i,r){e||(e=r,t=i,n=new Date,f(removeEventListener),u())},u=function(){if(t>=0&&t<n-a){var r={entryType:"first-input",name:e.type,target:e.target,cancelable:e.cancelable,startTime:e.timeStamp,processingStart:e.timeStamp+t};i.forEach((function(e){e(r)})),i=[]}},s=function(e){if(e.cancelable){var t=(e.timeStamp>1e12?new Date:performance.now())-e.timeStamp;"pointerdown"==e.type?function(e,t){var n=function(){c(e,t),a()},i=function(){a()},a=function(){removeEventListener("pointerup",n,r),removeEventListener("pointercancel",i,r)};addEventListener("pointerup",n,r),addEventListener("pointercancel",i,r)}(t,e):c(t,e)}},f=function(e){["mousedown","keydown","touchstart","pointerdown"].forEach((function(t){return e(t,s,r)}))},p="hidden"===document.visibilityState?0:1/0;addEventListener("visibilitychange",(function e(t){"hidden"===document.visibilityState&&(p=t.timeStamp,removeEventListener("visibilitychange",e,!0))}),!0);o(),self.webVitals={firstInputPolyfill:function(e){i.push(e),u()},resetFirstInputPolyfill:o,get firstHiddenTime(){return p}}}();
`;

initDataDog();

function App(props: AppProps<{ cookies: any }>) {
  const [isFooterLoaded, setFooterLoaded] = useState(false);

  const {
    Component,
    pageProps,
    router: { pathname }
  } = props;
  const { cookies = {} } = props.pageProps;

  useEffect(() => {
    if (cookies['srch-remove-footer']) return;

    loadFooterMfe().then(() => setFooterLoaded(true));
  }, [cookies, pathname]);

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="initial-scale=1.0, width=device-width"
          key="viewport"
        />
        <link
          rel="icon"
          type="image/x-icon"
          href={`${assetsUrl}/icons/favicon.ico`}
          crossOrigin=""
        />
        <link
          rel="preload"
          href={`${assetsUrl}/fonts/BrandonText-Light.woff2`}
          as="font"
          type="font/woff2"
          crossOrigin=""
        />
        <link
          rel="preload"
          href={`${assetsUrl}/fonts/BrandonText-Bold.woff2`}
          as="font"
          type="font/woff2"
          crossOrigin=""
        />
        <link
          rel="preload"
          href={`${assetsUrl}/fonts/BrandonText-Regular.woff2`}
          as="font"
          type="font/woff2"
          crossOrigin=""
        />
        <link
          rel="apple-touch-icon-precomposed"
          href="/Content/images/apple-touch-57px.png?v=2018.5.14_18.8.34"
        />
        <link
          rel="apple-touch-icon-precomposed"
          sizes="72x72"
          href="/Content/images/apple-touch-72px.png?v=2018.5.14_18.8.34"
        />
        <link
          rel="apple-touch-icon-precomposed"
          sizes="114x114"
          href="/Content/images/apple-touch-114px.png?v=2018.5.14_18.8.34"
        />
        <script
          type="text/javascript"
          dangerouslySetInnerHTML={{ __html: webVitalsPolyfill }}
        />
      </Head>
      <ThemeProvider theme={theme}>
        <div className="max-w-[1800px] mx-auto">
          <Component {...pageProps} />
          {isFooterLoaded ? <Footer /> : null}
        </div>
      </ThemeProvider>
    </>
  );
}

export default App;
